import React from "react";
import { compose, graphql } from "react-apollo";

import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { SENSORS_QUERY } from "../generalRegisterQueries";
import { CREATE_SENSOR_MUTATION } from "../generalRegisterMutations";
import SensorModal from "./SensorModal";

const SensorCreate = ({
  createSensor,
  snackbarContext,
  toggleModal,
  isOpen,
}) => {
  const onSave = (sensor) => {
    createSensor({
      variables: {
        params: sensor
      },
      refetchQueries: [{
        query: SENSORS_QUERY
      }]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Sensor criado.");
        toggleModal();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };

  return (
    <SensorModal
      toggleModal={toggleModal}
      isOpen={isOpen}
      title="Cadastrar sensor"
      onSave={onSave}
    />
  );
};

export default compose(
  graphql(CREATE_SENSOR_MUTATION, { name: "createSensor", }),
  withSnackbarConsumer,
)(SensorCreate);
